import { BOOL, GPA_MAX_LENGTH } from "../../util/constants";
import { dropdownSubtypes, inputMappings } from "../../util/enums";

export const formSections = [
  {
    id: "combined-degree-program",
    questions: [
      {
        title: "Current Career",
        id: "career-type",
        required: true,
        type: inputMappings.dropDown,
        dataField: "currentCareer",
        subtype: dropdownSubtypes.careerType
      },
      {
        title: "Proposed Graduation Plan",
        id: "graduation-information-plan",
        required: true,
        type: inputMappings.dropDown,
        dataField: "academicPlan",
        subtype: dropdownSubtypes.proposedGraduatePrograms
      },
      {
        id: "app-submitted-radio",
        type: inputMappings.checkbox,
        defaultValue: BOOL.NO,
        dataField: "isApplicationSubmitted",
        choices: [
          {
            id: "app-submitted-grad-admissions",
            title: "Application Submitted to Graduate Admissions?",
            value: BOOL.YES
          }
        ]
      },
      {
        title: "Matriculation Term",
        id: "matriculation-term",
        required: true,
        type: inputMappings.dropDown,
        subtype: dropdownSubtypes.term,
        dataField: "termCode",
        filter: {
          showFromPresent: 5
        }
      },
      {
        title: "CUM Undergrad GPA",
        id: "cum-undergrad-gpa",
        required: true,
        dataField: "cumUndergradGPA",
        type: inputMappings.numberInput,
        inputProps: {
          max: 4,
          maxLength: GPA_MAX_LENGTH,
          min: 0,
          onInput: (event) => { // enforce maxLength
            const value = event.target.value;
            const maxLength = GPA_MAX_LENGTH; // ensures maxLength cannot be manipulated on the UI
            if(value.length > maxLength) {
              event.target.value = value.slice(0, maxLength);
            }
          },
          step: 0.1
        }
      },
      {
        id: "courses-input-group",
        title: "Courses",
        dataField: "courses",
        type: inputMappings.inputGroup,
        numberOfResponsesMinimum: 1,
        numberOfResponsesMaximum: 10,
        questions: [
          {
            id: "courses-ig-subject-area",
            type: inputMappings.textInput,
            title: "Department",
            summary: null,
            required: true,
            dataField: "department",
            gridProps: {
              xs: 12,
              sm: 6,
              md: 3
            }
          },
          {
            id: "courses-ig-term",
            type: inputMappings.dropDown,
            subtype: dropdownSubtypes.term,
            dataField: "termCode",
            title: "Term",
            summary: null,
            required: true,
            gridProps: {
              xs: 12,
              sm: 6,
              md: 3
            },
            filter: {
              showFromPresent: 8
            }
          },
          {
            id: "courses-ig-number",
            type: inputMappings.textInput,
            title: "Course Number",
            dataField: "courseNumber",
            summary: null,
            required: true,
            gridProps: {
              xs: 12,
              sm: 6,
              md: 3
            }
          },
          {
            id: "courses-ig-credit-hours",
            type: inputMappings.numberInput,
            title: "Credit Hours",
            dataField: "creditHours",
            summary: null,
            required: true,
            gridProps: {
              xs: 12,
              sm: 6,
              md: 3
            },
            inputProps: {
              min: 0
            }
          }
        ]
      },
      {
        id: "record-update-complete",
        type: inputMappings.checkbox,
        dataField: "recordUpdateComplete",
        defaultValue: BOOL.NO,
        hidden: true,
        choices: [
          {
            id: "record-update-complete-yes",
            title: "Record Update Complete",
            value: BOOL.YES
          }
        ]
      }
    ]
  }
];

export const gradSchoolPreApprovalQuestions = [
  {
    id: "approvers",
    type: inputMappings.inputGroup,
    title: "Approvers",
    subtitle: "OSU Employees",
    required: true,
    numberOfResponsesMinimum: 1,
    numberOfResponsesMaximum: 5,
    dataField: "approvers",
    deleteAll: true,
    questions: [
      {
        id: "approver-info",
        type: inputMappings.approverLookup,
        title: "OSU Employee"
      }
    ]
  }
];

export const gradSchoolApprovalQuestions = [
  {
    id: "record-update-complete",
    type: inputMappings.checkbox,
    dataField: "recordUpdateComplete",
    choices: [
      {
        id: "record-update-complete-yes",
        title: "Record Update Complete",
        value: BOOL.YES
      }
    ]
  }
];

export const finalApprovalQuestions = [
  {
    id: "record-update-complete",
    type: inputMappings.checkbox,
    dataField: "recordUpdateComplete",
    choices: [
      {
        id: "record-update-complete-yes",
        title: "Record Update Complete",
        value: BOOL.YES
      }
    ]
  }
];

export const additionalFilters = [
  {
    id: "record-update-complete",
    title: "Record Update Complete",
    required: false,
    type: inputMappings.dropDown,
    choices: [
      {
        id: "all-record-update-complete",
        title: "All",
        value: "ALL"
      },
      {
        id: "yes-record-update-complete",
        title: "Yes",
        value: "Y"
      },
      {
        id: "no-record-update-complete",
        title: "No",
        value: "N"
      }
    ]
  }
];
